export const checkIsGuest = (userType: string) => ['guest', 'unknown'].includes(userType)
